var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconaUserSidebar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.4,
    height: 38,
    viewBox: "0 0 42.4 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6400",
    "data-name": "Group 6400",
    transform: "translate(-5476 1351)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_37",
    "data-name": "Union 37",
    d: "M5,38a5,5,0,0,1-5-5V5A5,5,0,0,1,5,0H33a5,5,0,0,1,5,5v9.106l3.95,3.951a1.524,1.524,0,0,1,.35.5,1.566,1.566,0,0,1,0,1.1,1.524,1.524,0,0,1-.35.5L38,24.108V33a5,5,0,0,1-5,5Z",
    transform: "translate(5476 -1351)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "person_FILL1_wght400_GRAD0_opsz48",
    d: "M21.079,21.212a5.88,5.88,0,0,1-6.131-6.131A5.88,5.88,0,0,1,21.079,8.95a5.88,5.88,0,0,1,6.131,6.131,5.88,5.88,0,0,1-6.131,6.131ZM8,34.332V30.49a4.5,4.5,0,0,1,.777-2.657,4.986,4.986,0,0,1,2-1.676,30.722,30.722,0,0,1,5.252-1.839,21.231,21.231,0,0,1,5.048-.613,20.338,20.338,0,0,1,5.027.634,34.817,34.817,0,0,1,5.232,1.819,4.928,4.928,0,0,1,2.044,1.676,4.5,4.5,0,0,1,.777,2.657v3.842Z",
    transform: "translate(5474.121 -1353.864)",
    fill: "#1d3943"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconaUserSidebar);
export default __webpack_public_path__ + "static/media/icona_user_sidebar.d142d15a0065a0cb1eba27155812d462.svg";
export { ForwardRef as ReactComponent };